<div class="matrix_layoutMain container" v-bind:class="getClassNameContainer">
  <div class="row matrix_layoutPackingContainerMainRow">
    <div class="col-md-3 matrix_layoutPackingContainerSidebar">
      <appSimpleTable :tableName="getContainerLabel(1)" useClass="matrix_compositionTable">
        <div class="matrix_optionsContainer">
          <appOptionsContainer hideContainer="true" optionsType="composition"></appOptionsContainer>
        </div>
      </appSimpleTable>  
      <appSimpleTable :tableName="getContainerLabel(2)" useClass="matrix_dimensionsTable">
          <appPackingOptionsContainer
            hideContainer="true"
          ></appPackingOptionsContainer>
          <appPreviewButton></appPreviewButton>
          <appAddToCartButton v-if="getAddToCartFullPage || getForceDisablePersonalization"></appAddToCartButton>        
      </appSimpleTable>
      <appSimpleTable :tableName="getContainerLabel(3)" useClass="matrix_impressionTable">
        <div class="matrix_optionsContainer">
          <appOptionsContainer hideContainer="true" optionsType="impression"></appOptionsContainer>
        </div>
        <appUploadButton></appUploadButton>
      </appSimpleTable>  
      <!-- <appOtherOptionsTable>
        <appOtherOptionsContainer></appOtherOptionsContainer>
      </appOtherOptionsTable> -->
    </div>
    <div class="col-md-6 matrix_layoutPackingContainerMain">
      <appPackingPreview></appPackingPreview>
      <div class="matrix_layoutPackingActions">
        <appDownloadPDFButton></appDownloadPDFButton>
      </div>
      <appUploadContainer></appUploadContainer>      
    </div>
    <div class="col-md-3 matrix_layoutPackingContainerQuantity">
      <appSimpleTable :tableName="getContainerLabel(4)" useClass="matrix_optionsTable">
        <div class="matrix_optionsContainer">
          <appOptionsContainer hideContainer="true" optionsType="options"></appOptionsContainer>
        </div>
      </appSimpleTable> 
      <appQuantityTable :quantityTableName="getContainerLabel(5)">
        <appQuantityContainer></appQuantityContainer>
        <appInputQuantity></appInputQuantity>
      </appQuantityTable>
      <div class="matrix_summaryInformation">
        <appFactsheet></appFactsheet>
      </div>
      <appPersonalizationButton></appPersonalizationButton>
      <appAddToCartButton v-if="getAddToCartFullPage || getForceDisablePersonalization"></appAddToCartButton>
    </div>
  </div>
</div>
